var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMatrixLogoBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3.25C2.25 3.25 2.25 2.83579 2.54289 2.54289C2.54289 2.54289 2.83579 2.25 3.25 2.25H12.75C12.75 2.25 13.1642 2.25 13.4571 2.54289C13.4571 2.54289 13.75 2.83579 13.75 3.25V12.75C13.75 12.75 13.75 13.1642 13.4571 13.4571C13.4571 13.4571 13.1642 13.75 12.75 13.75H3.25C3.25 13.75 2.83579 13.75 2.54289 13.4571C2.54289 13.4571 2.25 13.1642 2.25 12.75V3.25ZM3.25 3.25V12.75H12.75V3.25H3.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.75V13.25C7.5 13.5261 7.72386 13.75 8 13.75C8.27614 13.75 8.5 13.5261 8.5 13.25V2.75C8.5 2.47386 8.27614 2.25 8 2.25C7.72386 2.25 7.5 2.47386 7.5 2.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.5H2.75C2.47386 7.5 2.25 7.72386 2.25 8C2.25 8.27614 2.47386 8.5 2.75 8.5H13.25C13.5261 8.5 13.75 8.27614 13.75 8C13.75 7.72386 13.5261 7.5 13.25 7.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrixLogoBtn);
export default __webpack_public_path__ + "static/media/matrix-logo-btn.f97c43311c40f11206674b4c38390b46.svg";
export { ForwardRef as ReactComponent };